import { createStore } from 'vuex'
import fish from "./modules/fish"
export default createStore({
  modules:{
    fish
  }
})
